export const con = {
  apiKey: process.env.REACT_APP_FIREBASE,
  authDomain: process.env.REACT_APP_FIREBASE2,
  projectId: process.env.REACT_APP_FIREBASE3,
  storageBucket: process.env.REACT_APP_FIREBASE4,
  messagingSenderId: process.env.REACT_APP_FIREBASE5,
  appId: process.env.REACT_APP_FIREBASE6,
};
